export default __webpack_public_path__ + "static/media/MECH.48c5ee56.jpg";